import gql from "graphql-tag";

export const GET_POWERPLANTS = gql`
  {
    powerplants {
      power_plant_id
      name
      power
      power_monthly
      owners {
        name
        logo_url
        percent
      }
      consumerunits {
        installation_number
        label
      }
    }
  }
`;

export const GET_POWERPLANTCOMBO = gql`
  {
    powerplants {
      name
      power_plant_id
      power_monthly
    }
  }
`;

// Query
export const GET_POWER_PLANT = gql`
  query powerplant($id: String!) {
    powerplant(id: $id) {
      power_plant_id
      owners {
        name
        percentage
        recipient_id
        partner_id
      }
    }
  }
`;
